import { DeleteOutlined } from "@ant-design/icons";
import { Flex, Form } from "antd";
import { useState } from "react";
import { ContractProduct, ContractType } from "tm-shared/types";
import { sanitizeIntegerInput } from "tm-shared/utils";

import BaseButton from "@/components/BaseButton";
import { ContractFormValues } from "@/types/form";
import { handleFocus } from "@/utils/dom/handleFocus";

import { StyledInputNumber } from "../../Styled";
import { AddProductsModal } from "../AddProductsModal";
import { ContractProductRow } from "./ContractProductRow";
import { StyledErrorsWrapper } from "./Styled";

export const PaidProductInput: React.FC = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const form = Form.useFormInstance<ContractFormValues>();

    const selectedProducts = Form.useWatch("products", form) || [];

    const menuItems = [
        {
            key: "1",
            label: (
                <Flex gap="5px" align="center">
                    <DeleteOutlined /> Видалити
                </Flex>
            ),
        },
    ];

    return (
        <>
            <Flex vertical gap={20} style={{ marginBottom: 24 }}>
                <BaseButton type="primary" onClick={() => setIsModalOpen(true)}>
                    Обрати товари
                </BaseButton>

                <Flex vertical gap={12}>
                    <Form.List
                        name="products"
                        rules={[
                            {
                                validator: async (
                                    _,
                                    products?: ContractProduct[],
                                ) => {
                                    const bad = products?.some(
                                        ({ price }) => !price || price <= 0,
                                    );
                                    if (bad)
                                        throw new Error(
                                            "У всіх товарів має бути ціна",
                                        );
                                },
                            },
                        ]}
                    >
                        {(fields, { remove, add }, { errors }) => (
                            <>
                                {fields.map((field) => {
                                    const productName = form.getFieldValue([
                                        "products",
                                        field.name,
                                        "name",
                                    ]);

                                    return (
                                        <ContractProductRow
                                            key={field.key}
                                            productName={productName}
                                            field={field}
                                            menuItems={menuItems}
                                            remove={remove}
                                        />
                                    );
                                })}

                                <StyledErrorsWrapper>
                                    <Form.ErrorList errors={errors} />
                                </StyledErrorsWrapper>

                                <AddProductsModal
                                    contractType={ContractType.PaidProductInput}
                                    open={isModalOpen}
                                    onClose={() => setIsModalOpen(false)}
                                    selectedProducts={selectedProducts}
                                    onAdd={add}
                                    onRemove={(barcode) => {
                                        const index =
                                            selectedProducts.findIndex(
                                                (p) => p.barcode === barcode,
                                            );
                                        if (index !== -1) remove(index);
                                    }}
                                />
                            </>
                        )}
                    </Form.List>
                </Flex>
            </Flex>

            <Form.Item<ContractFormValues>
                name="paybackPeriod"
                label="Період окупності в днях:"
                rules={[{ required: true, message: "Введіть число" }]}
            >
                <StyledInputNumber
                    min={0}
                    onFocus={handleFocus}
                    inputMode="numeric"
                    textAlign="left"
                    placeholder="Поле для введення"
                    style={{ width: "100%" }}
                    parser={sanitizeIntegerInput}
                />
            </Form.Item>
        </>
    );
};
